import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { apiClient } from '@app/apiClient';
import { useMobxInstance } from '@client/clientUtils/mobxUtil';

class ViewStore {
    buildVersion = import.meta.env.VITE_BUILD_VERSION;
    gitHash = import.meta.env.VITE_GIT_HASH;
    buildTime = import.meta.env.VITE_BUILD_TIME;
    isNewVersionAvailable = false;

    constructor() {
        makeAutoObservable(this);
    }

    async fetchBuildVersion() {
        const data = await apiClient.common.public.getBuildVersion.$query(undefined, {
            ttl: 1000 * 60, // 1분
        });

        const serverBuildVersion = data;

        if (
            serverBuildVersion?.buildVersion &&
            serverBuildVersion.buildVersion !== this.buildVersion
        ) {
            this.isNewVersionAvailable = true;
        }
    }
}

const BuildVersion = observer(() => {
    const location = useLocation();
    const viewStore = useMobxInstance(ViewStore);

    useEffect(() => {
        if (location.pathname === '/') {
            viewStore.fetchBuildVersion();
        }
    }, [location.pathname]);

    return (
        <div className="text-base-content/70 flex w-full flex-col gap-2 text-xs">
            {viewStore.isNewVersionAvailable && (
                <button
                    className="btn btn-block btn-primary"
                    onClick={() => {
                        window.location.reload();
                    }}
                >
                    새 버전으로 업데이트
                </button>
            )}
            <div>Version: {viewStore.buildVersion}</div>
        </div>
    );
});

export default BuildVersion;
